import { UmbracoNode } from "../models/UmbracoNode"
import { format } from 'date-fns';

export type UpcomingEventItemsModel = {
  nodes: UmbracoNode[] | null
}

export default function UpcomingEventItems({ nodes }: UpcomingEventItemsModel) {
  return (
    <>
      <ul className="block-list">
        <>
        { (nodes && nodes.length > 0) && nodes.map((node, index) => {
            const startDate = new Date(node.properties["dateStart"]);
            return (
              <li key={`upcoming-event-item-${index}`}>
                <a href={node.url}>{node.name} - <span>{format(startDate, 'MMM d')}</span></a>
              </li>
            )
          })
        }
        </>
      </ul>
    </>
  )
} 